module.exports = __webpack_public_path__ + "img/汪寿阳-4x.b67e201e.png";